import React, { useState } from 'react';
import api, { errMsg, getUser, saveSession } from '../services/api';
import Msg from '../components/Msg';

export default function Account() {
  const user = getUser();
  const [pw, setPw] = useState({ currentPassword: '', newPassword: '' });
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async e => {
    e.preventDefault();
    setBusy(true); setMsg(null);
    try {
      const r = await api.post('/api/auth/change-password', pw);
      saveSession(r.data); // sesiune noua; celelalte dispozitive sunt deconectate
      setPw({ currentPassword: '', newPassword: '' });
      setMsg({ type: 'ok', text: 'Parola a fost schimbată.' });
    } catch (err) {
      setMsg({ type: 'err', text: errMsg(err) });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <h2>Contul meu</h2>
      <p className="muted">{user?.email}</p>
      <div className="card narrow">
        <h3>Schimbă parola</h3>
        <form onSubmit={submit}>
          <label>Parola curentă
            <input type="password" required autoComplete="current-password" value={pw.currentPassword}
              onChange={e => setPw({ ...pw, currentPassword: e.target.value })} />
          </label>
          <label>Parola nouă (minim 10 caractere)
            <input type="password" required minLength={10} autoComplete="new-password" value={pw.newPassword}
              onChange={e => setPw({ ...pw, newPassword: e.target.value })} />
          </label>
          <Msg msg={msg} />
          <button className="btn btn-primary" disabled={busy}>Schimbă parola</button>
        </form>
      </div>
    </div>
  );
}
